import React from 'react';

import { Box } from '@rover/kibble/core';

export interface ContainerProps {
  children: React.ReactNode;
  height?: string;
  disableScroll?: boolean;
}

const Container: React.FC<ContainerProps> = ({ children, height, disableScroll }) => {
  if (disableScroll) {
    return <Box paddingX="1x">{children}</Box>;
  }

  return (
    <Box height={height} maxHeight={height ?? '450px'} paddingX="1x" sx={{ overflowY: 'auto' }}>
      {children}
    </Box>
  );
};

export default Container;
